import StackAPI from '@/lib/StackAPI'
import Storage from '@/lib/Storage'
import { isEmpty } from '@/utils/isEmpty'
import { captureException } from '@sentry/react'

export type ResponseType = {
  included: []
}

export const getPartnerDetails = async () => {
  const role = Storage().getActiveRole()

  if (isEmpty(role)) return { error: 'no active role' }

  const { organizationId } = role

  const PARTNER_DETAILS_ENDPOINT = `api/organizations/${organizationId}?include=publishers,vendors,affiliates`

  const { get } = StackAPI()

  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json'
  }

  const request = {
    path: PARTNER_DETAILS_ENDPOINT,
    headers
  }

  try {
    const response = await get<ResponseType>(request)

    return response.data
  } catch (error) {
    captureException(error, { extra: { organizationId, role } })
    return { error: (error as Error).message || 'unknown error' }
  }
}
